import React, { useState, useCallback, useEffect, useRef } from "react";
import filter from "../../../../images/filter.svg";
import search from "../../../../images/search.svg";
import DatePicker, { registerLocale } from "react-datepicker";
import { Controller } from "react-hook-form";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import {
  capitalize,
  translateStatus,
  filterOptionById,
} from "../../../../assets/helpers/funciones";
import {
  providerStatus,
  validationAPIErrorCheckbox,
  NO_RECOMMENDED_PROVIDER,
} from "../../../../assets/helpers/options";
import authService from "../../../../services/authService";
import copyImage from "../../../../images/copyImage.svg";
import { Dropzone, FileComponent } from "../../Dropzone/Dropzone";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useDropzone } from "react-dropzone";
import { notify } from "../../../../assets/helpers/toast";
import PhoneInput from "react-phone-number-input";
import { parsePhoneNumber } from "libphonenumber-js";
import eye from "../../../../images/eye-outline.svg";
import eyeOff from "../../../../images/eye-off-outline.svg";

import "./Input.scss";
import useProvidersPayment from "../../../../hooks/useProvidersPayment";
registerLocale("es", es);

export const FilterDatePicker = (props) => {
  const {
    label,
    bootstrap,
    minDate,
    maxDate,
    data,
    name,
    placeholder,
    value,
    onChange,
    disabled,
    dateFormat = "dd/MM/yyyy",
  } = props;
  return (
    <div className={`input-component-container ${bootstrap}`}>
      {data?.subLabel && !label ? "" : <label htmlFor={name}>{label}</label>}

      <div>
        <div className="input-sublabel-container">
          {data?.subLabel && <h6>{data?.subLabel}</h6>}
          <DatePicker
            dateFormat={dateFormat}
            placeholderText={placeholder}
            onChange={onChange}
            selected={value}
            name="Hasta"
            locale="es"
            autoComplete="off"
            minDate={minDate || data?.minDate}
            maxDate={maxDate || data?.maxDate}
            disabled={disabled || data?.disabled}
          />
        </div>
      </div>
    </div>
  );
};

// EYE component that shows or hyde password
export const ShowPassword = (props) => {
  const { type, inputType, showPassword } = props;

  if (type === "password" && inputType !== "text") {
    return (
      <img
        className="eye-component"
        src={eye}
        alt="eye"
        onClick={showPassword}
      />
    );
  }
  if (type === "password" && inputType === "text") {
    return (
      <img
        className="eye-component"
        src={eyeOff}
        alt="eyeOff"
        onClick={showPassword}
      />
    );
  } else return null;
};

export const SelectInput = (props) => {
  const {
    onChange,
    bootstrap,
    label,
    name,
    register,
    options,
    errors,
    disabled,
    capitalizeOff,
    noBlankOption,
  } = props;

  return (
    <div className={`input-component-container ${bootstrap}`}>
      <label htmlFor={name}>{label}</label>
      <div>
        <select
          className="input-select"
          onChange={onChange}
          {...register(name, {
            onChange: onChange,
          })}
          name={name}
          disabled={disabled}
        >
          {!noBlankOption && <option value=""></option>}
          {options?.map((o, i) => (
            <option key={o?._id} value={o?._id}>
              {capitalizeOff ? o?.name : capitalize(o?.name?.toLowerCase())}
            </option>
          ))}
        </select>
      </div>

      <p>{errors}</p>
    </div>
  );
};

export const SelectInputWithSearch = (props) => {
  const {
    options,
    label,
    name,
    onChange,
    bootstrap,
    errors,
    disabled,
    capitalizeOff,
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [textField, setTextField] = useState("");

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    setFilteredOptions(
      options.filter((o) => o?.name?.toLowerCase().includes(term))
    );
  };

  const handleSelect = (value) => {
    onChange({ target: { name, value } });
    setTextField(
      capitalize(filteredOptions.find((o) => o?._id === value)?.name) || ""
    );

    setIsOpen(false);
  };

  return (
    <div className={`input-component-container ${bootstrap}`}>
      <label htmlFor={name}>{label}</label>
      <div className="custom-select-container">
        <div
          className={`custom-select ${isOpen ? "open" : ""}`}
          onClick={handleToggle}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          <span>{textField || "Seleccione una opción"}</span>
        </div>
        {isOpen && (
          <div
            className="custom-select-dropdown"
            style={{
              maxHeight: "210px",
              overflowY: "auto",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          >
            {options?.length > 10 && (
              <input
                type="text"
                placeholder="Buscar..."
                value={searchTerm}
                onChange={handleSearch}
                className="custom-select-search"
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  backgroundColor: "#fff",
                  padding: "8px",
                  borderBottom: "1px solid #ccc",
                }}
              />
            )}
            <ul
              className="custom-select-options"
              style={{
                padding: "0 10px",
              }}
            >
              {filteredOptions.map((o) => (
                <li
                  key={o?._id}
                  onClick={() => handleSelect(o?._id)}
                  className="custom-select-option"
                  style={{
                    cursor: "pointer",
                    padding: "5px",
                    backgroundColor: "#fff",
                    listStyle: "none",
                    padding: "2px",
                    margin: 0,
                  }}
                >
                  {capitalizeOff ? o?.name : capitalize(o?.name?.toLowerCase())}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <p>{errors}</p>
    </div>
  );
};

export const OneOptionTableFilter = (props) => {
  const {
    options,
    label,
    name,
    onChange,
    bootstrap,
    errors,
    disabled,
    capitalizeOff,
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [textField, setTextField] = useState("");
  const [hovered, setHovered] = useState(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    setFilteredOptions(
      options.filter((o) => o?.name?.toLowerCase().includes(term))
    );
  };

  const handleSelect = (value) => {
    onChange(value);
    setTextField(
      capitalize(filteredOptions.find((o) => o?._id === value)?.name) || ""
    );
    setIsOpen(false);
  };

  useEffect(() => {
    const initialFilteredOptions = options.filter(
      (option) => option !== undefined
    );
    setFilteredOptions(initialFilteredOptions);
  }, [options]);
  return (
    <div
      style={{
        position: "relative",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
      }}
    >
      <div className="custom-select-container">
        <div
          className={`custom-select ${isOpen ? "open" : ""}`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "none",
            textAlign: "center",
            borderRadius: "4px",
            fontSize: "16px",
            fontWeight: "700",
            color: "#000",
          }}
        >
          <span>{label}</span>

          <img
            src={filter}
            alt="filtrar"
            className=""
            onClick={handleToggle}
            style={{
              cursor: "pointer",
            }}
          />
        </div>
        {isOpen && (
          <div
            className="custom-select-dropdown"
            style={{
              maxHeight: "210px",
              minWidth: "170px",
              overflowY: "auto",
              borderRadius: "4px",
              border: "1px solid #ccc",
              padding: "0",
              position: "absolute",
              fontWeight: "400",
              zIndex: 10,
            }}
          >
            {options?.length > 10 && (
              <input
                type="text"
                placeholder="Buscar..."
                value={searchTerm}
                onChange={handleSearch}
                className="custom-select-search"
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  backgroundColor: "#fff",
                  padding: "8px",
                  borderBottom: "1px solid #ccc",
                }}
              />
            )}
            <ul
              className="custom-select-options"
              style={{ padding: "0", margin: 0, width: "100%" }}
            >
              {filteredOptions.map((o) => (
                <li
                  key={o?._id}
                  onClick={() => handleSelect(o?._id)}
                  className="custom-select-option"
                  style={{
                    cursor: "pointer",
                    listStyle: "none",
                    padding: "5px",
                    paddingLeft: "10px",
                    margin: 0,
                    backgroundColor: hovered === o?._id ? "#f27730" : "#fff", // Cambiar color
                    color: hovered === o?._id ? "#fff" : "#000",
                  }}
                  onMouseEnter={() => setHovered(o?._id)} // Detectar hover
                  onMouseLeave={() => setHovered(null)}
                >
                  {o?.name}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <p>{errors}</p>
    </div>
  );
};

export const Input = (props) => {
  const {
    bootstrap,
    label,
    type,
    title,
    name,
    register,
    placeholder,
    options,
    errors,
    data,
    subLabel,
    control,
    onChange,
    disabled,
    min,
    max,
    minDate,
    capitalizeOff,
    maxDate,
    noBlankOption,
    numpadForMobile,
  } = props;

  const [inputType, setInputType] = useState(type);

  const showPassword = () => {
    inputType === "password" ? setInputType("text") : setInputType("password");
  };

  let errorInput = "i";
  if (errors) {
    errorInput = "error-input";
  }

  if (title) {
    return (
      <>
        <div
          style={{ marginTop: "30px" }}
          className="filter-button-container"
        ></div>
        <h5 className="form-input-title">{title}</h5>
      </>
    );
  }

  if (type === "checkbox") {
    return (
      <CheckboxInput
        subLabel={data?.subLabel || subLabel}
        bootstrap={bootstrap}
        label={label}
        name={name}
        register={register}
        errorInput={errorInput}
        errors={errors}
        onChange={onChange || data?.onChange}
        disabled={disabled}
      />
    );
  }

  if (type === "select") {
    return (
      <SelectInput
        options={data?.options || options}
        bootstrap={bootstrap}
        label={label}
        type={type}
        name={name}
        register={register}
        placeholder={placeholder}
        errors={errors}
        disabled={disabled || data?.disabled}
        onChange={onChange || data?.onChange}
        capitalizeOff={capitalizeOff}
        noBlankOption={noBlankOption}
      />
    );
  }

  if (type === "phone") {
    return (
      <div className={`input-component-container ${bootstrap}`}>
        {data?.subLabel && !label ? "" : <label htmlFor={name}>{label}</label>}
        <Controller
          name={name}
          control={control}
          rules={{
            required: "El teléfono es obligatorio",
            validate: (value) => {
              if (!value) return true;

              const countryCode = control._getWatch("countryCode") || "58";
              const restOfNumber = value.replace(`+${countryCode}`, "");

              if (restOfNumber.startsWith(countryCode)) {
                return "No repitas el código de área";
              }
              if (restOfNumber.startsWith("0")) {
                return "No incluyas el 0 inicial";
              }
              return true;
            },
          }}
          render={({ field: { onChange: onPhoneChange, value } }) => (
            <PhoneInput
              inputMode={numpadForMobile ? "tel" : "text"}
              placeholder=""
              value={value}
              disabled={disabled || data?.disabled}
              onChange={(val) => {
                let cleanValue = val;
                let countryCodeValue = "";

                try {
                  const parsedNumber = parsePhoneNumber(val);
                  if (parsedNumber) {
                    countryCodeValue = parsedNumber.countryCallingCode;

                    const rawValue = parsedNumber.number;
                    const doubleCode = `+${countryCodeValue}${countryCodeValue}`;

                    if (rawValue.startsWith(doubleCode)) {
                      cleanValue = rawValue.replace(
                        doubleCode,
                        `+${countryCodeValue}`
                      );
                    }
                  }
                } catch (err) {
                  countryCodeValue = "";
                }

                onPhoneChange(cleanValue);
                control._formValues.countryCode = countryCodeValue;
              }}
              defaultCountry={"VE"}
            />
          )}
        />
        <p>{errors}</p>
      </div>
    );
  }

  if (type === "select-mobile") {
    return (
      <SelectInputWithSearch
        options={data?.options || options}
        bootstrap={bootstrap}
        label={label}
        type={type}
        name={name}
        register={register}
        placeholder={placeholder}
        errors={errors}
        disabled={disabled || data?.disabled}
        onChange={onChange || data?.onChange}
        capitalizeOff={capitalizeOff}
      />
    );
  }

  if (type === "textarea") {
    return (
      <div className={`input-component-container ${bootstrap}`}>
        {data?.subLabel && !label ? "" : <label htmlFor={name}>{label}</label>}

        <div>
          <div className="input-sublabel-container">
            {data?.subLabel && <h6>{data?.subLabel}</h6>}
            <textarea
              id={name}
              className={`${errorInput}`}
              type={inputType}
              name={name}
              onChange={onChange}
              {...register(name, {
                onChange: onChange,
              })}
              placeholder={placeholder}
              autoComplete="off"
              disabled={disabled || data?.disabled}
            />
          </div>
        </div>

        <p>{errors}</p>
      </div>
    );
  }

  if (type === "date") {
    return (
      <div className={`input-component-container ${bootstrap}`}>
        {data?.subLabel && !label ? "" : <label htmlFor={name}>{label}</label>}

        <div>
          <div className="input-sublabel-container">
            {data?.subLabel && <h6>{data?.subLabel}</h6>}
            <Controller
              control={control}
              name={name}
              render={({ field }) => (
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  placeholderText={placeholder}
                  onChange={(date) => {
                    field.onChange(date);
                    onChange?.(date);
                  }}
                  selected={field.value}
                  locale="es"
                  autoComplete="off"
                  minDate={minDate || data?.minDate}
                  maxDate={maxDate || data?.maxDate}
                  disabled={disabled || data?.disabled}
                />
              )}
            />
          </div>
        </div>
        <p>{errors}</p>
      </div>
    );
  }

  if (type === "date-time") {
    return (
      <div className={`input-component-container ${bootstrap}`}>
        {data?.subLabel && !label ? "" : <label htmlFor={name}>{label}</label>}

        <div>
          <div className="input-sublabel-container">
            {data?.subLabel && <h6>{data?.subLabel}</h6>}
            <Controller
              control={control}
              name={name}
              render={({ field }) => (
                <DatePicker
                  dateFormat="dd/MM/yyyy HH:mm"
                  placeholderText={placeholder}
                  onChange={(date) => field.onChange(date)}
                  selected={field.value}
                  locale="es"
                  autoComplete="off"
                  minDate={minDate || data?.minDate}
                  maxDate={maxDate || data?.maxDate}
                  disabled={disabled || data?.disabled}
                  showTimeSelect
                  // alling the time select to the right of the date picker
                  timeFormat="HH:mm"
                  timeCaption="Hora"
                  calendarClassName="custom-calendar"
                  className="custom-datepicker"
                  wrapperClassName="custom-datepicker-wrapper"
                />
              )}
            />
          </div>
        </div>
        <p>{errors}</p>
      </div>
    );
  }

  if (type === "time-picker") {
    return (
      <div className={`input-component-container ${bootstrap}`}>
        {data?.subLabel && !label ? "" : <label htmlFor={name}>{label}</label>}

        <div>
          <div className="input-sublabel-container">
            {data?.subLabel && <h6>{data?.subLabel}</h6>}
            <Controller
              control={control}
              name={name}
              render={({ field }) => (
                <DatePicker
                  dateFormat="h:mm aa"
                  placeholderText={placeholder}
                  onChange={(date) => field.onChange(date)}
                  selected={field.value}
                  locale="es"
                  autoComplete="off"
                  minDate={minDate || data?.minDate}
                  maxDate={maxDate || data?.maxDate}
                  disabled={disabled || data?.disabled}
                  showTimeSelect
                  showTimeSelectOnly
                  timeFormat="h:mm aa"
                  timeCaption="Hora"
                  calendarClassName="custom-calendar"
                  className="custom-datepicker"
                  wrapperClassName="custom-datepicker-wrapper"
                />
              )}
            />
          </div>
        </div>
        <p>{errors}</p>
      </div>
    );
  }

  if (name) {
    return (
      <div className={`input-component-container ${bootstrap}`}>
        {data?.subLabel && !label ? "" : <label htmlFor={name}>{label}</label>}

        <div>
          <div className="input-sublabel-container">
            {data?.subLabel && <h6>{data?.subLabel}</h6>}
            <input
              id={name}
              className={`${errorInput}`}
              type={inputType}
              name={name}
              onChange={onChange}
              {...register(name, {
                onChange: onChange,
              })}
              placeholder={placeholder}
              autoComplete="off"
              disabled={disabled || data?.disabled}
              min={min || data?.min}
              max={max || data?.max}
              onWheel={
                inputType === "number" ? (e) => e.target.blur() : undefined
              }
              onKeyDown={
                inputType === "number"
                  ? (e) => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault();
                      }
                    }
                  : undefined
              }
            />
          </div>

          <ShowPassword
            type={type}
            inputType={inputType}
            showPassword={showPassword}
          />
        </div>

        <p>{errors}</p>
      </div>
    );
  } else {
    return <div className={`input-component-container ${bootstrap}`}></div>;
  }
};

export const SelectPerPage = (props) => {
  const { options, label, value, onChange } = props;
  return (
    <div className="select-per-page">
      <label htmlFor="label">{label}</label>
      <select name="" id="label" onChange={(e) => onChange(e)} value={value}>
        {options?.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </div>
  );
};

export const Select = (props) => {
  const { name, options, label, value, onChange } = props;
  return (
    <div className="simple-select">
      <label htmlFor="label">{label}</label>
      <select
        name={name}
        id="label"
        onChange={(e) => onChange(e)}
        value={value}
      >
        {options?.map((o) => (
          <option key={o?.name} value={o?._id}>
            {capitalize(o?.name)}
          </option>
        ))}
      </select>
    </div>
  );
};

export const CheckboxInput = (props) => {
  const {
    bootstrap,
    subLabel,
    errorInput,
    name,
    register,
    errors,
    onChange,
    disabled,
  } = props;

  return (
    <div className={`input-component-container ${bootstrap}`}>
      {/* <label htmlFor={name}>{label}</label> */}
      <div className="checkbox-input-sublabel-container">
        <input
          id={name}
          className={`checkbox-input  ${errorInput}`}
          type={"checkbox"}
          name={name}
          onChange={onChange}
          {...register(name, {
            onChange: onChange,
          })}
          autoComplete="off"
          disabled={disabled}
        />
        <h6>{subLabel}</h6>
      </div>
      <p>{errors}</p>
    </div>
  );
};

export const SearchInput = (props) => {
  const { placeholder, width, value, onChange, searchAction } = props;

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      searchAction();
    }
  };

  return (
    <div className="incidence-search">
      <div className="searchImageContainers">
        <img src={search} alt="search" onClick={() => searchAction()} />
      </div>
      <input
        style={{ width: width }}
        className="service-search-input"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={(e) => handleKeyDown(e)}
      />
    </div>
  );
};

export const SelectProvider = (props) => {
  const {
    onChange,
    bootstrap,
    label,
    name,
    options,
    errors,
    value,
    hideStatus,
    noProviderLabel,
  } = props;

  // Cerrajeria muestra solo el nombre del proveedor, sin "(Estado)"
  const statusLabel = (status) =>
    hideStatus ? "" : `  (${status})`;

  const getProviderSortOrder = (provider) => {
    if (!provider?.isActive) return 2;
    if (provider?.status === providerStatus.available) return 0;
    return 1;
  };

  const sortedOptions = [...(options || [])].sort(
    (a, b) => getProviderSortOrder(a) - getProviderSortOrder(b)
  );

  return (
    <div className={`input-component-container ${bootstrap}`}>
      <label htmlFor={name}>{label}</label>
      <div>
        <select
          className="input-select"
          onChange={onChange}
          value={value}
          name={name}
        >
          <option value=""></option>
          {noProviderLabel && (
            <option value={NO_RECOMMENDED_PROVIDER}>{noProviderLabel}</option>
          )}
          {sortedOptions?.map((o, i) => {
            if (!o?.isActive) {
              return (
                <option
                  style={{ color: "#D3D3D3" }}
                  key={o?._id}
                  value={o?._id}
                >
                  {capitalize(o?.contactName?.toLowerCase())}
                  {statusLabel(" Inactivo")}
                </option>
              );
            }
            if (o?.status === providerStatus.available) {
              return (
                <option key={o?._id} value={o?._id}>
                  {capitalize(o?.contactName?.toLowerCase())}
                  {statusLabel(translateStatus(o?.status))}
                </option>
              );
            } else {
              return (
                <option style={{ color: "red" }} key={o?._id} value={o?._id}>
                  {capitalize(o?.contactName?.toLowerCase()) + "   "}
                  {statusLabel(translateStatus(o?.status))}
                </option>
              );
            }
          })}
        </select>
      </div>

      <p>{errors}</p>
    </div>
  );
};

export const PaymentSection = (props) => {
  const {
    payment,
    watch,
    setValue,
    options,
    register,
    errors,
    index,
    returnAccountData,
    fileUploaded,
    setFileUploaded,
    onChange,
    showErrorAPI,
  } = props;

  const selectedMethodName = filterOptionById(
    options?.paymentMethods,
    watch(`method${index}`)
  )?.name;
  const showApiValidationCheckbox =
    payment?.skipApiValidationError &&
    validationAPIErrorCheckbox.includes(selectedMethodName) &&
    showErrorAPI &&
    authService.getUser();
  const { getPaymentsData } = useProvidersPayment();
  const setLoading = onChange?.setIsloading;

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        if (!["image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
          notify("Agregar un formato valido de imagen", "error");
          return;
        }

        const maxWeight = 3;
        if (file.size * 0.000001 > maxWeight) {
          notify(`La imagen no debe superar los ${maxWeight} MB`, "error");
          return;
        }

        const files = [...fileUploaded];
        files[index] = file;
        setFileUploaded(files);

        getPaymentsData({
          paymemtMethodOptions: options?.paymentMethods,
          file,
          index,
          watch,
          setValue,
          setIsloading: setLoading,
          methodField: `method${index}`,
          referenceField: `reference${index}`,
          dateField: `date${index}`,
        });
      });
    },
    [
      fileUploaded,
      index,
      options?.paymentMethods,
      watch,
      setValue,
      setFileUploaded,
      setLoading,
      getPaymentsData,
    ]
  );

  const removeFile = (index) => {
    let files = fileUploaded;
    files[index] = "";
    setFileUploaded([...files]);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  return (
    <>
      {payment?.name?.includes("method") && (
        <CopyComponent
          watch={watch}
          payment={payment}
          options={options}
          returnAccountData={returnAccountData}
        />
      )}
      {payment?.bootstrap && (
        <Input
          key={payment?.label}
          bootstrap={payment?.bootstrap}
          label={payment?.label}
          type={payment?.type}
          name={payment?.name}
          register={register}
          placeholder={""}
          errors={payment?.errors}
          options={
            index === 0
              ? options?.paymentMethods
              : payment?.name?.includes("cashReceiver")
              ? options?.cashReceiverOptions
              : options?.filteredMethods
          }
          min={"1"}
          disabled={payment?.disabled}
          onChange={onChange?.setBsRate}
        />
      )}

      {payment?.dropzone && fileUploaded && (
        <div className={`${payment?.bootstrap || 'col-6'}`}>
          <label className="dropzone-label">{payment?.label}</label>
          {fileUploaded[index] ? (
            <FileComponent
              file={fileUploaded[index]}
              remove={() => removeFile(index)}
            />
          ) : (
            <Dropzone
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              message={"(PNG, JPG, JEPG, máx. 3MB)"}
            />
          )}
        </div>
      )}

      {showApiValidationCheckbox && (
        <div
          className="col-12"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          <h6 style={{ color: "red", marginRight: "10px", marginBottom: "0" }}>
            No Validado por API
          </h6>
          <Input
            bootstrap={""}
            label={""}
            type={"checkbox"}
            name={`skipApiValidationError${index}`}
            register={register}
            placeholder={""}
            errors={errors?.[`skipApiValidationError${index}`]?.message}
            disabled={false}
          />
        </div>
      )}
    </>
  );
};

export const CopyComponent = (props) => {
  const { watch, payment, options, returnAccountData } = props;

  if (watch(`${payment?.name}`) && payment?.type === "select") {
    return (
      <CopyToClipboard
        text={returnAccountData(
          options.paymentMethods,
          watch(`${payment?.name}`)
        )}
      >
        <div className="col-3 copy-payment-data-image-button-container">
          <img
            className="copy-payment-data-image-button"
            src={copyImage}
            alt="copyImage"
          />
          <h6>Copiar datos de pago</h6>
        </div>
      </CopyToClipboard>
    );
  } else return <div className="col-3"></div>;
};

export const TableFilter = ({ options, label, disabled, onSearch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const clearFilters = () => {
    setSelectedValues([]);
    onSearch([]);
    setIsOpen(false);
  };

  const handleSearch = () => {
    onSearch(selectedValues);
    setIsOpen(false);
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedValues(filteredOptions.map((option) => option._id));
    } else {
      setSelectedValues([]);
    }
  };

  const handleOptionChange = (e) => {
    const value = e.target.value;
    setSelectedValues((prevSelectedValues) => {
      const newSelectedValues = prevSelectedValues.includes(value)
        ? prevSelectedValues.filter((v) => v !== value)
        : [...prevSelectedValues, value];

      // Desmarcar "Seleccionar todo" si no todas las opciones están seleccionadas
      if (newSelectedValues.length !== filteredOptions.length) {
        setSelectAll(false);
      }
      return newSelectedValues;
    });
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchTerm) {
      const filtered = options.filter((option) =>
        option.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered.filter((option) => option !== undefined));
    } else {
      setFilteredOptions(options.filter((option) => option !== undefined));
    }
  }, [searchTerm, options]);

  useEffect(() => {
    setFilteredOptions(options.filter((option) => option !== undefined));
  }, [options]);

  return (
    <div
      className="select-multiple-with-search"
      style={{ position: "relative" }}
    >
      <img src={filter} alt="filtrar" className="" onClick={handleToggle} />
      {isOpen && (
        <div className="dropdown-container" ref={dropdownRef}>
          {options.length > 15 && (
            <input
              type="text"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-bar"
              key={"search-bar"}
            />
          )}
          <div className="options-container-multiple">
            <div key={"select-all"} className="option-multiple">
              <input
                type="checkbox"
                id={"select-all"}
                checked={selectAll}
                onChange={handleSelectAllChange}
                disabled={disabled}
              />
              <label
                htmlFor={"select-all"}
                style={{ fontWeight: "normal", textAlign: "initial" }}
              >
                {"Seleccionar todo"}
              </label>
            </div>
            {label === "Asesor Asignado" && (
              <div key={"unnassigned"} className="option-multiple">
                <input
                  type="checkbox"
                  id={"unnassigned"}
                  value={"unnassigned"}
                  checked={selectedValues.includes("unnassigned")}
                  onChange={handleOptionChange}
                  disabled={disabled}
                />
                <label
                  htmlFor={"unnassigned"}
                  style={{ fontWeight: "normal", textAlign: "initial" }}
                >
                  {"No asignado"}
                </label>
              </div>
            )}
            {filteredOptions?.map((o) => (
              <div key={o?._id} className="option-multiple">
                <input
                  type="checkbox"
                  id={o?._id}
                  value={o?._id}
                  checked={selectedValues.includes(o?._id)}
                  onChange={handleOptionChange}
                  disabled={disabled}
                />
                <label
                  htmlFor={o?._id}
                  style={{ fontWeight: "normal", textAlign: "initial" }}
                >
                  {o?.name}
                </label>
              </div>
            ))}
          </div>
          <div className="buttons-container">
            <button
              className="search-button"
              disabled={disabled}
              onClick={() => handleSearch()}
            >
              Buscar
            </button>
            <button
              className="clear-filters-button"
              onClick={clearFilters}
              disabled={selectedValues.length === 0 ? true : false}
            >
              Limpiar Filtros
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export const TableDateFilter = ({ label, disabled, onSearch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const clearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    onSearch({});
    setIsOpen(false);
  };

  const handleSearch = () => {
    onSearch(startDate, endDate);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="select-multiple-with-search"
      style={{ position: "relative" }}
    >
      <img src={filter} alt="filtrar" className="" onClick={handleToggle} />
      {isOpen && (
        <div
          className="dropdown-container"
          ref={dropdownRef}
          style={{ borderRadius: "4px" }}
        >
          <DatePicker
            selected={startDate}
            onChange={handleChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            inline
            className="custom-datepicker"
            calendarClassName="custom-calendar"
          />
          <div
            className="buttons-container"
            style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}
          >
            <button
              className="search-button"
              disabled={disabled}
              onClick={() => handleSearch()}
            >
              Buscar
            </button>
            <button
              className="clear-filters-button"
              onClick={clearFilters}
              disabled={startDate === null && endDate === null ? true : false}
            >
              Limpiar Filtros
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export const SearchServiceInput = ({
  label,
  name,
  register,
  setValue,
  errors,
  getServicesByCode,
  control,
  watch,
  disabled,
}) => {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    // Si usas react-hook-form v7+, puedes usar watch directamente
    if (watch) {
      const code = watch("serviceCode");
      if (code && code !== query) setQuery(code);
    }
  }, [watch, query]);

  // Buscar servicios cuando hay al menos 5 caracteres después del guion
  const handleChange = async (e) => {
    const value = e.target.value.toUpperCase();
    setQuery(value);

    // Solo dispara la búsqueda si después del guion hay al menos 5 caracteres
    const match = value.match(/-(.{5,})$/);
    if (match) {
      setLoading(true);
      const res = await getServicesByCode(value); // Busca usando todo el valor
      const services = res?.service?.slice(0, 6) || [];
      setSuggestions(services);
      setShowSuggestions(true);
      setLoading(false);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
    // Limpia los campos si el usuario borra el input
    setValue("clientName", "");
    setValue("clientPhone", "");
    setValue("serviceId", "");
  };
  // Cuando selecciona una sugerencia
  const handleSelect = (service) => {
    setValue("serviceId", service._id); // El valor real es el id
    setQuery(service.code); // Pero se muestra el code
    setValue(
      "clientName",
      `${service.customer.firstName} ${service.customer.lastName}`
    );
    setValue("serviceCode", service.code);
    setValue("clientPhone", service.customer.phone);
    setShowSuggestions(false);
    setSuggestions([]);
  };

  return (
    <div
      className="input-component-container col-6"
      style={{ position: "relative" }}
    >
      <label htmlFor={name}>{label}</label>
      <input
        id={name}
        className={`form-control`}
        type="text"
        name={name}
        value={query}
        onChange={handleChange}
        placeholder="Buscar código de servicio"
        autoComplete="off"
        disabled={disabled}
        ref={inputRef}
        style={{ textTransform: "uppercase" }}
      />
      {/* Sugerencias */}
      {showSuggestions && (
        <ul
          style={{
            position: "absolute",
            zIndex: 10,
            background: "#fff",
            width: "95%",
            border: "1px solid #ccc",
            maxHeight: "180px",
            overflowY: "auto",
            listStyle: "none",
            top: "82%",
            left: 0,
            padding: 0,
            margin: 0,
            marginLeft: "3%",
            borderRadius: "4px",
          }}
        >
          {loading && (
            <span
              className="spinner"
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                width: "20px",
                height: "20px",
              }}
            />
          )}
          {!loading && suggestions.length === 0 && (
            <li style={{ padding: "8px" }}>Sin resultados</li>
          )}
          {suggestions.map((s) => (
            <li
              key={s._id}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
              }}
              onClick={() => handleSelect(s)}
            >
              <b>{s.code}</b>
            </li>
          ))}
        </ul>
      )}
      {/* Campo oculto para el id */}
      <input type="hidden" {...register("serviceId")} />
      {errors?.serviceId && (
        <span className="text-danger">{errors.serviceId.message}</span>
      )}
    </div>
  );
};
